import { render, staticRenderFns } from "./ConceptStatus.vue?vue&type=template&id=ba9d13ca&scoped=true"
import script from "./ConceptStatus.vue?vue&type=script&lang=ts"
export * from "./ConceptStatus.vue?vue&type=script&lang=ts"
import style0 from "./ConceptStatus.vue?vue&type=style&index=0&id=ba9d13ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9d13ca",
  null
  
)

export default component.exports